<template>
  <div class="index">
    <template>
      <div class="block">
        <img v-if="allDataObj.positionA && allDataObj.positionA.length > 0" :src="allDataObj.positionA[0].bannerImg" alt="" class="fixPositionA" @click="$router.push(allDataObj.positionA[0].navigateUrl)" />
        <div class="fixPositionB" v-if="allDataObj.positionB && allDataObj.positionB.length > 0 && isPositionB">
          <img :src="allDataObj.positionB[0].bannerImg" alt="" class="fixPositionBImg" @click="$router.push(allDataObj.positionB[0].navigateUrl)" />
          <img src="../../../static/image/closeBtn.png" alt="" class="closeImg" @click="handleClose()" />
        </div>
        <div class="categoryBox">
          <div class="categoryList" v-for="(item, index) in categoryList" :key="index" @click="
              $router.push({
                path: '/categoryGoods',
                query: { pcFirstCategoryId:item.id}
              })
            ">
            <div class="categoryList_top">
              <img :src="item.iconUrl" alt="" class="categoryList_icon" />
              <span class="categoryList_title">{{ item.text }} </span>
              <i class="iconfont categoryList_arrow">&#xe624;</i>
            </div>
            <!-- <span class="categoryList_subTitle" v-if="item.children.length > 0"
              >{{ item.children[0].text
              }}<span class="line" v-if="item.children.length > 1"></span
              >{{ item.children.length > 1 ? item.children[1].text : "" }}</span
            > -->
            <!-- 二级分类 -->
            <div class="subCategoryBox">
              <div class="subCategoryList" v-for="(it, ind) in item.children" :key="ind" @click.stop="
                  $router.push({
                    path: '/categoryGoods',
                    query: { pcCategoryIds: it.id ,pcFirstCategoryId:item.id}
                  })
                ">
                <span>{{ it.text }}</span>
                <i class="iconfont subCategory_arrow">&#xe624;</i>
              </div>
            </div>
          </div>
        </div>

        <el-carousel height="400px" style="flex: 1" :interval="5000" indicator-position="none" @change="changeBanner" arrow="always" :autoplay="true">
          <!-- calc(27.78vw - 13.9px) -->
          <el-carousel-item v-for="(item, index) in allDataObj.shuf" :key="index" ref="carouselItem">
            <video-player v-if="item.bannerType == 11 && item.video != ''" class="video-player vjs-custom-skin" ref="videoPlayer" :playsline="false" :options="playerOptions(item.video)" @play="onPlayerPlay($event)" @ended="onPlayerEnd($event)"></video-player>
            <img v-else :src="item.bannerImg" class="bannerImg" @click="$router.push(item.navigateUrl)" />
          </el-carousel-item>
        </el-carousel>
        <div class="block_box">
          <div class="blockBox_name" v-if="userName">欢迎您，{{ name }}</div>
          <div class="blockBox_btnBox">
            <div class="blockBox_btnList" @click="$router.push('/personal')">
              <img src="/static/image/personalIcon.png" alt="" />
              <span>采购人中心</span>
            </div>
            <div class="blockBox_btnLine"></div>
            <div class="blockBox_btnList" @click="$router.push('/myInvoice')">
              <img src="/static/image/invoiceIcon.png" alt="" />
              <span>发票中心</span>
            </div>
          </div>
          <div class="blockBox_subTitleBox">
            <span class="blockBox_subTitle" @click="$router.push('/infoCenter')">资讯</span>
          </div>
          <div class="blockBox_textList" v-for="(item, index) in infoList" :key="index" @click="
              $router.push({
                path: '/infoDetails',
                query: { id: item.id }
              })
            ">
            <span class="blockBox_text">{{ item.title }}</span>
            <span class="blockBox_time">{{ getDate(item.createTime) }}</span>
          </div>
        </div>
      </div>
    </template>
    <!-- 帮促专区 -->
    <img v-if="allDataObj.helpPoorBanner && allDataObj.helpPoorBanner.length > 0" :src="allDataObj.helpPoorBanner[0].bannerImg" alt="" style="display:block;width: 1200px;height: 252px;margin: 23px auto 0;cursor: pointer;" @click="$router.push(allDataObj.helpPoorBanner[0].navigateUrl)" />
    <div class="advertisementBox" v-if="allDataObj.centerAdsense && allDataObj.centerAdsense.length > 0">
      <img class="advertisementImg" v-for="(item, index) in allDataObj.centerAdsense" :key="index" :src="item.bannerImg" @click="$router.push(item.navigateUrl)" />
    </div>
    <div class="content">
      <!--促销模块-->
      <div class="promotions" id="promotions" v-if="allDataObj.plate && allDataObj.plate.length > 0">
        <div class="promotion-item" v-for="(item, index) in allDataObj.plate" :key="index" @click="$router.push(item.navigateUrl)">
          <img :src="item.bannerImg" />
        </div>
      </div>
      <!--固定横幅-->
      <!-- <div class="fiexdImg">
        <img src="../../../static/image/fixedImg.png" /> -->
      <!-- <div class="videoBox">
          <div class="videoBox_titleBox">
            <span class="videoBox_title">视频中心</span>
            <el-link
              type="primary"
              :underline="false"
              style="
                font-size: 12px;
                font-family: PingFang SC, PingFang SC-Regular;
                font-weight: 400;
                color: #f37920;
              "
              >更多>></el-link
            >
          </div>
          <div class="videoBox_main">
            <div class="videoBox_mainLeft">
              <video-player
                class="video-player vjs-custom-skin"
                ref="videoPlayer"
                :playsline="false"
                :options="playerOptions"
              ></video-player>
              <div class="videoBox_mainLeftTitle">xxxxxxxx标题</div>
            </div>
            <div class="videoBox_mainRight">
              <div class="videoBox_list">
                <video-player
                  class="video-player vjs-custom-skin"
                  ref="videoPlayer2"
                  :playsline="false"
                  :options="playerOptions2"
                ></video-player>
                <div class="videoBox_mainLeftTitle">xxxxxxxx标题</div>
              </div>
              <div class="videoBox_list">
                <video-player
                  class="video-player vjs-custom-skin"
                  ref="videoPlayer3"
                  :playsline="false"
                  :options="playerOptions3"
                ></video-player>
                <div class="videoBox_mainLeftTitle">xxxxxxxx标题</div>
              </div>
            </div>
          </div>
        </div> -->
      <!-- </div> -->
      <!--问题链接-->
      <div class="question-des">
        <div v-for="(item, index) in allDataObj.centerques" :key="index" style="cursor: pointer" @click="$router.push(item.navigateUrl)">
          <img :src="img[index]" alt="" />{{ item.bannerTitle }}
        </div>
        <!-- <div>如何成为采购人</div>
        <div>如何购买</div>
        <div>如何结算</div> -->
      </div>
      <!--楼层-->
      <div class="floor" v-for="(floor, index) in moduleData" v-if="floor.goodsInfoList.length > 0" :key="index">
        <img class="floor-left" :src="floor.icon" />
        <div class="floor-right">
          <div class="floor-right-category">
            <div class="goods-category">
              <div @click="
                  $router.push({
                    path: '/categoryGoods',
                    query: { pcCategoryIds: item.id ,pcFirstCategoryId:item.parentId}
                  })
                " class="goods-categoryList" v-for="(item, index) in floor.childrenCate" :key="index">
                {{ item.text }}
              </div>
            </div>
            <div class="show-more" @click="
                $router.push({
                  path: '/categoryGoods',
                  query: { pcFirstCategoryId: floor.pcCategoryId,}
                })
              ">
              查看更多
            </div>
          </div>
          <div class="floor-goods">
            <div class="goods-item" v-for="(goods, ind) in floor.goodsInfoList" :key="ind">
              <template v-if="goods.itemType == 1">
                <img class="advert-img" :src="goods.imgUrl" @click="gotoDetails(goods.id)" />
              </template>
              <template v-else>
                <div class="floor-imgBox">
                  <video-player v-if="goods.indexShowVideo == 1 && goods.video != ''" class="video-player vjs-custom-skin" ref="videoPlayer2" :playsline="false" :options="playerOptions2(goods.video)"></video-player>
                  <img class="goods-img" :src="goods.thumb" @click="gotoDetails(goods.id)" v-else />

                  <img @click="gotoDetails(goods.id)" v-if="goods.indexShowVideo != 1" class="tag-img" :src="
                      goods.helpPoor == 0
                        ? ''
                        : goods.helpPoor == 1
                        ? '../../../static/image/helpPoor.png'
                        : goods.helpPoor == 2
                        ? '../../../static/image/832.png'
                        : goods.helpPoor == 3
                        ? '../../../static/image/cooperation.png'
                        : goods.helpPoor == 4
                        ? '../../../static/image/characteristic.png'
                        : goods.helpPoor == 5
                        ? '../../../static/image/support.png'
                        : goods.helpPoor == 6
                        ? '../../../static/image/helpDisabled.png'
                        : goods.helpPoor == 7
                        ? '../../../static/image/veterans.png'
                        : ''
                    " />
                </div>
                <div class="goods-title" @click="gotoDetails(goods.id)">
                  {{ goods.title }}
                </div>
                <span class="goods-price" v-if="goods.intervalPriceList" @click="gotoDetails(goods.id)">￥{{ goods.intervalPriceList[0].price }}</span>
              </template>
            </div>
          </div>
        </div>
      </div>
      <!--问题链接-->
      <div class="question-des">
        <div v-for="(item, index) in question2" :key="index" style="cursor: pointer">
          <img :src="img2[index]" alt="" />{{ item }}
        </div>
        <!-- <div>精准帮扶</div>
        <div>爱心直达</div>
        <div>控源保质</div>
        <div>售后无忧</div> -->
      </div>
      <div class="wxcode">
        <img src="/static/image/wxcode.jpg" />
      </div>
    </div>

    <!-- 右侧nav -->
    <div class="right_nav">
      <div class="right_navList" @click="$router.push('/shopCar')">
        <i class="iconfont" style="font-size: 30px">&#xe690;</i><span>购</span><span>物</span><span>车</span>
        <span class="shopCarNum">{{ shopCarNum }}</span>
      </div>
      <div class="right_navList2">
        <div class="right_navList2_items" @click="
            visible = true;
            isHelp = true;
          ">
          <i class="iconfont">&#xe613;</i>
        </div>
        <!-- <div
          class="right_navList2_items"
          style="border-top:1px solid #fff;border-bottom:1px solid #fff"
        >
          <i class="iconfont">&#xe6c2;</i>
        </div>
        <div class="right_navList2_items">
          <i class="iconfont">&#xe61d;</i>
        </div> -->
      </div>
      <div class="right_navList3" @click="gotoTop()">
        <i class="iconfont" style="font-size: 18px">&#xe666;</i>
        <span>返</span><span>回</span><span>顶</span><span>部</span>
      </div>
    </div>
    <Dialog :dialogVisible="visible" @closepop="visible = false" width="1000px">
      ><img :src="indexAd ? indexAd.adPicUrl : ''" alt="" style="width:100%;cursor: pointer;" slot="content" v-if="!isHelp" @click="jumpTo(indexAd.router)" />
    </Dialog>
  </div>
</template>
<script>
import { doPost, doGet } from "../common/HttpHelper.js";
import { httpConfig } from "../common/config.js";
import dialog from "../common/dialog.vue";
import { videoPlayer } from "vue-video-player";
import "video.js/dist/video-js.css";

export default {
  name: "HelloWorld",
  components: {
    Dialog: dialog,
    videoPlayer,
  },
  data() {
    return {
      isPositionB: true,
      visible: false,
      isFirst: sessionStorage.getItem("isFirst"),
      isHelp: false,
      indexAd: "", //首页开屏广告
      allDataObj: {},
      moduleData: [],
      categoryList: [], //分类列表
      shopCarNum: 0,

      img: [
        "../../../../static/image/如何成为采购人.svg",
        "../../../../static/image/如何成为供应商.svg",
        "../../../../static/image/如何购买.svg",
        "../../../../static/image/如何结算.svg",
      ],
      question2: ["精准帮扶", "产地保证", "信用认证", "售后无忧"],
      img2: [
        "../../../../static/image/精准帮扶.svg",
        "../../../../static/image/产地保证.svg",
        "../../../../static/image/信用认证.svg",
        "../../../../static/image/售后无忧.svg",
      ],
      playerOptions(video) {
        return {
          playbackRates: [0.7, 1.0, 1.5, 2.0], // 播放速度
          autoplay: false, // 如果true,浏览器准备好时开始回放。
          muted: false, // 默认情况下将会消除任何音频。
          loop: false, // 导致视频一结束就重新开始。
          preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
          language: "zh-CN",
          aspectRatio: "778:400", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
          fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
          sources: [
            {
              type: "video/mp4", // 这里的种类支持很多种：基本视频格式、直播、流媒体等，具体可以参看git网址项目
              src: video, // url地址
            },
          ],
          poster: "", // 你的封面地址
          width: document.documentElement.clientWidth, // 播放器宽度
          notSupportedMessage: "此视频暂无法播放，请稍后再试", // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
          controlBar: {
            timeDivider: true,
            durationDisplay: true,
            remainingTimeDisplay: false,
            fullscreenToggle: true, // 全屏按钮
          },
        };
      },
      playerOptions2(video) {
        return {
          playbackRates: [], // 播放速度
          autoplay: false, // 如果true,浏览器准备好时开始回放。
          muted: false, // 默认情况下将会消除任何音频。
          loop: false, // 导致视频一结束就重新开始。
          preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
          language: "zh-CN",
          aspectRatio: "170:170", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
          fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
          sources: [
            {
              type: "video/mp4", // 这里的种类支持很多种：基本视频格式、直播、流媒体等，具体可以参看git网址项目
              src: video, // url地址
            },
          ],
          poster: "", // 你的封面地址
          width: document.documentElement.clientWidth, // 播放器宽度
          notSupportedMessage: "此视频暂无法播放，请稍后再试", // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
          controlBar: {
            timeDivider: true, // 当前时间和持续时间的分隔符
            durationDisplay: false, // 显示持续时间
            remainingTimeDisplay: false, // 是否显示剩余时间功能
            currenttimedisplay: false, // 当前时间
            // volumecontrol: false, // 声音控制键
            // playtoggle: false, // 暂停和播放键
            // progresscontrol: false, // 进度条
            fullscreentoggle: true, // 全屏按钮
          },
        };
      },
      playerOptions3: {
        playbackRates: [0.7, 1.0, 1.5, 2.0], // 播放速度
        autoplay: false, // 如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        aspectRatio: "150:85", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          {
            type: "video/mp4", // 这里的种类支持很多种：基本视频格式、直播、流媒体等，具体可以参看git网址项目
            src: "https://media.st.dl.pinyuncloud.com/steam/apps/81745/movie_max.mp4", // url地址
          },
        ],
        poster: "", // 你的封面地址
        width: document.documentElement.clientWidth, // 播放器宽度
        notSupportedMessage: "此视频暂无法播放，请稍后再试", // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true, // 全屏按钮
        },
      },
      isAutoPlay: true, //是否自动播放banner
      infoList: "", //资讯列表
      userName: this.$cookies.get("userInfo")
        ? this.$cookies.get("userInfo").pcAccount
        : "",
      name: this.$cookies.get("userInfo")
        ? this.$cookies.get("userInfo").name
        : "",
    };
  },
  mounted() {
    let that = this;
    doGet(
      httpConfig.Index.IndexAdUrl,
      {},
      function (res) {
        if (res.flag) {
          that.indexAd = res.data;
          if (!that.isFirst) {
            that.visible = true;
            sessionStorage.setItem("isFirst", false);
            that.isFirst = true;
          }
        }
      },
      function (res) {}
    );

    doPost(
      httpConfig.Index.InfoUrl,
      {},
      function (res) {
        that.allDataObj = that.distributeAllData(res);
      },
      function (res) {}
    );
    doPost(
      httpConfig.Index.indexModuleUlr,
      {},
      function (res) {
        that.moduleData = res.data;
      },
      function (res) {}
    );
    doGet(
      httpConfig.infoDetails.getTopListByLocation,
      { location: 2, limit: 5 },
      function (res) {
        that.infoList = res;
        that.$nextTick(() => {
          that.Truancate(".blockBox_text");
        });
      },
      function (res) {}
    );
    doGet(
      httpConfig.Category.findCategoriesUrl,
      {},
      function (res) {
        that.categoryList = res.data;
      },
      function (res) {}
    );
    this.getShopCar();
  },
  methods: {
    /**
     * 文本截断
     */
    Truancate($element) {
      var nodeList = document.querySelectorAll($element);
      var elements = Array.prototype.slice.call(nodeList, 0);
      elements.forEach(function (element) {
        var str = element.innerHTML;
        if (element.offsetHeight > 19) {
          for (var i = 0; i <= str.length; i++) {
            element.innerHTML = str.slice(0, i);
            if (element.offsetHeight > 19) {
              element.innerHTML = str.slice(0, i - 3) + "......";
              break;
            }
          }
          element.style.minWidth = "calc(100% - 12px)";
        } else {
          element.style.minWidth = "calc(100% - 12px)";
        }
      });
    },
    /**
     * 时间格式化（补0）
     */
    add0(m) {
      return m < 10 ? "0" + m : m;
    },
    /**
     * 时间戳转换
     */
    getDate(time) {
      if (!time) return "";
      if (time == typeof string) {
        var reg = getRegExp("-", "g"); // 获取正则表达式，全局替换
        time = time.replace(reg, "/");
      }
      var date = new Date(time);
      var M = date.getMonth() + 1;
      var y = date.getFullYear();
      var d = date.getDate();
      var h = date.getHours();
      var mm = date.getMinutes();
      var s = date.getSeconds();
      if (M < 10) M = "0" + M;
      if (d < 10) d = "0" + d;
      return (
        y + "-" + M + "-" + d
        // +
        // " " +
        // this.add0(h) +
        // ":" +
        // this.add0(mm) +
        // ":" +
        // this.add0(s)
      );
    },
    /**
     * 跳转链接
     */
    jumpTo(e) {
      window.location.href = e;
    },
    /**
     * 获取购物车
     */
    getShopCar() {
      var that = this;
      doGet(
        httpConfig.shopCar.getShopCarUrl,
        {  type: 0 },
        function (res) {
          if (res.flag) {
            var shopCar = res.data;
            that.shopCarNum = 0;
            shopCar.forEach((item) => {
              item.info = JSON.parse(item.info);
              that.shopCarNum += item.info.num; //计算购物车商品总数
            });
          }
        },
        function (res) {}
      );
    },
    //解析所有数据
    distributeAllData(res) {
      var newData = {};
      for (var i = 0; i < res.length; i++) {
        newData[res[i].code] = res[i].banners;
      }
      return newData;
    },
    //返回顶部
    gotoTop() {
      let top = document.documentElement.scrollTop || document.body.scrollTop;
      // 实现滚动效果
      const timeTop = setInterval(() => {
        document.body.scrollTop =
          document.documentElement.scrollTop =
          top -=
            50;
        if (top <= 0) {
          clearInterval(timeTop);
        }
      }, 10);
    },
    /**
     * 切换幻灯片
     */
    changeBanner(index, preIndex) {
      if (this.allDataObj.shuf[preIndex].bannerType == 11) {
        let tempIndex;
        let result = this.allDataObj.shuf.filter((item) => {
          return item.bannerType == 11;
        });
        result.some((item, index) => {
          tempIndex = index;
          return item == this.allDataObj.shuf[preIndex];
        });
        this.$refs.videoPlayer[tempIndex].player.pause();
        this.isAutoPlay = true;
      }
    },
    /**
     * 播放视频
     */
    onPlayerPlay($event) {
      this.isAutoPlay = false;
    },
    /**
     * 结束视频
     */
    onPlayerEnd($event) {
      this.isAutoPlay = true;
    },

    /**
     * 商品详情
     */
    gotoDetails(id) {
      this.$router.push({ path: "/goodsInfo", query: { id: id } });
    },
    /**
     * 关闭B广告位
     */
    handleClose() {
      this.isPositionB = false;
    },
    /**
     * 无效事件
     */
    nothing() {},
  },
};
</script>
<style scoped>
@import "../../assets/css/index";
</style>



// WEBPACK FOOTER //
// src/components/page/index.vue